<template>
  <page-outline :title="$t('Webheader.tpp_client')">
    <template slot="pageContent">
      <div class="listPage overflow-hidden">
        <b-row class="justify-content-start no-gutters">
          <div class="mx-3">
            <b-button class="btn btnFilter" :disabled="activateSpinner"
            :aria-label="$t('common.rfrsh')"
            @click="onRefresh">
            <i class="fa fa-rotate-right fs-14px"></i>
          </b-button>
          </div>
          <b-button variant="primary" class="mx-2" v-if="canAddTPPClient" :disabled="activateSpinner"
            @click="addTPPClient">
            {{ $t('administration.tpp_client.add_tpp_client') }}
          </b-button>
        </b-row>

        <br />

        <b-row>
          <b-col md="12">
            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <!-- DR : Changer de fixed à relative pour que les tables soient scrollable (pratique pour les users mobile/tablette)-->
              <b-table hover relative responsive
                v-if="TPPClients.length"
                class="mt-3 table-striped"
                :items="TPPClients"
                :fields="fields"
                :key="keyTableTPPClients"
                selectable select-mode="single" @row-selected="seeDetails">
                <template #cell()="data">
                  {{data.value ? data.value : '-'}}
                </template>
                <template #cell(Language)="data">
                  {{data.value ? $t('common.language_list.'+data.value) : '-'}}
                </template>
                <template #cell(Active)="data">
                  <i v-if="data.value === 1" class="fa-light fa-check btn btn-icon btn-icon-green"/>
                  <i v-else class="fa-duotone fa-xmark btn btn-icon btn-icon-red p-0 min-h-auto"/>
                </template>
              </b-table>
              <label class="font-bold w-100 d-flex justify-content-center mt-3" v-else>{{ $t('common.no_result') }}</label>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'

import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'TPPClientList',
  components: {
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    roleFromURL: {
      type: String,
      default: "0"
    },
  },
  data () {
    return {
      activateSpinner: false,
      keyTableTPPClients: false,
      TPPClients: [],
      pageCounter: 0,
      paginationObject: {},
      tabName: 0
    }
  },
  computed: {
    canAddTPPClient () {
      return this.$engine.rights.rightIs('tpp_client_ajouter', true)
    },
    fields () {
      let tmpFields = [
        { key: 'ClientId', label: this.$t('administration.tpp_client.client_id'), class: 'text-center table-condensed' },
        { key: 'Label', label: this.$t('administration.tpp_client.label'), class: 'text-center table-condensed' },
        { key: 'MemberId', label: this.$t('administration.tpp_client.tpp_member_id'), class: 'text-center table-condensed' },
        // { key: 'RedirectURL', label: this.$t('administration.tpp_client.tpp_redirect_url'), class: 'text-center table-condensed' },
        { key: 'Language', label: this.$t('administration.tpp_client.language'), class: 'text-center table-condensed' },
        { key: 'Active', label: this.$t('administration.tpp_client.active'), class: 'text-center table-condensed' }
      ]
      if (!this.$engine.rights.getCurrentCountry().idCountry) {
        tmpFields.push({ key: 'countryName', label: this.$t('administration.country'), class: 'text-center table-condensed' })
      }
      return tmpFields
    },
    role () {
      return this.tabName
    }
  },
  created () {
    this.pageCounter = 0
    this.paginationObject['maxResults'] = 25
    this.onRefresh()
  },
  methods: {
    addTPPClient () {
      loadPage(this, {url: '/tpp_client/form/add/-1'})
    },
    onRefresh (index = 1) {
      if (typeof index === 'object') {
        index = 1
      }
      this.activateSpinner = true
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.refreshItems()

      this.$f7.pullToRefreshDone()
    },
    refreshItems () {
      let that = this
      let params = {
      }
      this.$engine.administration.tppclient.fetch(
        params, this.paginationObject.maxResults, this.paginationObject.firstIndex
      ).then(resp => {
        let TPPClients = []

        that.paginationObject.nbResultsTotal = resp.data.countTotal
        that.paginationObject.nbResults = resp.data.TPPClients.length
        TPPClients = resp.data.TPPClients

        that.updateItems(TPPClients)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    seeDetails (items) {
      this.$engine.administration.tppclient.clickedClient = {...items[0]}
      this.keyTableTPPClients = !this.keyTableTPPClients
      loadPage(this, {url: '/tpp_client/form/details/' + items[0].IdTPPClient})
    },
    updateItems (requests) {
      this.TPPClients = requests
    }
  }
}
</script>
